var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavInfos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#212631;fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14Zm1.373-3.466.114-.453a1.816,1.816,0,0,1-.638.146c-.319.011-.377-.036-.465-.106a.483.483,0,0,1-.135-.4,2.035,2.035,0,0,1,.041-.342c.028-.151.591-2.152.606-2.313s.023-.273.023-.337a.951.951,0,0,0-.335-.753,1.416,1.416,0,0,0-.953-.29,3.575,3.575,0,0,0-1.532.4l-.113.453A1.857,1.857,0,0,1,5.626,6.4c.319-.01.377.036.458.11A.523.523,0,0,1,6.2,6.9c0,.105-.628,2.51-.646,2.633a2.629,2.629,0,0,0-.025.36.941.941,0,0,0,.344.748,1.444,1.444,0,0,0,.967.295,3.2,3.2,0,0,0,1.53-.4ZM8.231,4.558a.875.875,0,0,0,0-1.238.835.835,0,0,0-.616-.258.879.879,0,0,0-.877.877A.841.841,0,0,0,7,4.558a.852.852,0,0,0,.62.255.841.841,0,0,0,.616-.255Z",
    transform: "translate(1 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavInfos);
export default __webpack_public_path__ + "static/media/nav-infos.90b31c75342b7ff11d4b57efdc74a430.svg";
export { ForwardRef as ReactComponent };